module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_InvertedBadges_116x116_6-4af41513d71f20f9e539f2ec4db72a30.png";